import React from 'react';
import { UserSettings } from '../../components/UserSettings';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export const UserSettingsPage: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#050505] p-6">
      <button 
        onClick={() => navigate('/')}
        className="flex items-center gap-2 text-gray-400 hover:text-white mb-8 transition-colors group"
      >
        <ArrowLeft size={20} />
        <span className="font-mono text-xs uppercase tracking-widest">Back to Home</span>
      </button>
      <div className="max-w-2xl mx-auto">
        <UserSettings />
      </div>
    </div>
  );
};
